import React, {useEffect} from 'react';
import {Col, Image, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import LayerIcon from "../../data/icons/layer.png"
import AxcBadge from "../common/AxcBadge";
import Swal from "sweetalert2";
import {delAllSysFcltyDeptDetail, delCMFWFloors, delUserInfo} from "../../api/apiClient";

const FcltyFloorList = ({
                          propFcltyFloorList,
                          propSetFlctyFloorList,
                          propSelectedFloorIdx,
                          propSetSelectedFloorIdx,
                          propHandleFloorBtnClick,
                          propHandleOpenPopup,
                          propIsReadOnly,
                          updateList,
                          propSetIsFloorChanged
                        }) => {

  useEffect(() => {
    console.log(propFcltyFloorList);
  }, [propFcltyFloorList]);


  // save reference for dragItem and dragOverItem
  const dragItem = React.useRef();
  const dragOverItem = React.useRef();

  // const handle drag sorting
  const handleSort = () => {
    // duplicate items
    const items = [...propFcltyFloorList];
    // console.log(items);

    // remove and save the dragged item
    const draggedItem = items.splice(dragItem.current, 1)[0];
    // console.log(draggedItem);

    // switch position
    items.splice(dragOverItem.current, 0, draggedItem);

    // reset the position ref
    dragItem.current = null;
    dragOverItem.current = null;

    // update the actual array
    propSetFlctyFloorList(items);

    // 층 순서가 변경되었는지 상태 관리
    propSetIsFloorChanged(true);
  };

  // delete ////////////////////////////////////
  const delItem = (e) => {
    // const deleteId = e.target.dataset.id;
    const fclty_dtl_nm = e.target.dataset.fcltydtlnm;
    const fclty_dtl_no = e.target.dataset.fcltydtlno; // 층관리no
    const fclty_no = e.target.dataset.fcltyno;   // 시설관리no

    Swal.fire({
      title: `삭제하시겠습니까?`,
      text: `${fclty_dtl_nm} 층을 삭제합니다.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delCMFWFloors(fclty_dtl_no, fclty_no)
            .then(res => {
              if (res.data.status === 200) {
                Swal.fire(
                    '삭제되었습니다!',
                    '',
                    'success'
                );
                // setCheckItems([]);
                // setIsSearch(true);
                updateList();
                propSetSelectedFloorIdx(0);
              }
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
      }
    });
  };

  return (
      <Row className={"fclty-floor-list"}>
        {Array.isArray(propFcltyFloorList) && propFcltyFloorList.length !== 0 ?
            (propFcltyFloorList.map((elem, idx) => {
              return (
                  <Col md={12}
                       key={elem.fclty_dtl_nm}
                       className={"fclty-floor-list-item pt-2"}
                       draggable
                       onDragStart={(e) => dragItem.current = idx}
                       onDragEnter={(e) => dragOverItem.current = idx}
                       onDragEnd={handleSort}
                       onDragOver={(e) => e.preventDefault()}
                  >
                    <Row className={'justify-content-center'}>
                      <Col md={7}>
                        <Button
                            value={idx}
                            className={'position-relative w-100 floor-control-item mb-2 py-2' + (idx === propSelectedFloorIdx ? " active" : "")}
                            onClick={(e) => propHandleFloorBtnClick(e, idx)}
                            data-fcltydtlno={elem.fclty_dtl_no}
                            data-fcltyno={elem.fclty_no}
                        >
                          {elem.fclty_dtl_nm}
                          <span className={`position-absolute top-0 start-100 translate-middle badge rounded-pill 
                            ${elem.fire_co > 0 ? 'bg-danger' :
                              elem.cr_co > 0 ? 'bg-danger' :
                                  elem.mj_co > 0 ? 'bg-major' : 
                                      elem.mn_co > 0 ? 'bg-warning' : 'bg-success'} 
                            `}>
                            {elem.fire_co > 0 ? 'FIRE' :
                              elem.cr_co > 0 ? 'CR' :
                                  elem.mj_co > 0 ? 'MJ' :
                                      elem.mn_co > 0 ? 'MN' : 'NM'}
                          </span>
                        </Button>

                      </Col>
                      {propIsReadOnly ? '' : (
                          <>
                            <Col md={5}>
                              <Button
                                  variant={"primary"}
                                  value={idx}
                                  className={'mb-2'}
                                  onClick={(e) => {
                                    propHandleOpenPopup(e, false, elem.fclty_dtl_no, elem.fclty_dtl_nm)
                                  }}
                                  data-fcltydtlno={elem.fclty_dtl_no}
                                  data-fcltyno={elem.fclty_no}
                              >
                                {/*<small>*/}
                                  수정
                                {/*</small>*/}
                              </Button>
                              <span> </span>
                              <Button
                                  variant={"danger"}
                                  value={idx}
                                  className={'mb-2'}
                                  onClick={delItem}
                                  data-fcltydtlnm={elem.fclty_dtl_nm}
                                  data-fcltydtlno={elem.fclty_dtl_no}
                                  data-fcltyno={elem.fclty_no}
                              >
                                {/*<small>*/}
                                  삭제
                                {/*</small>*/}
                              </Button>
                            </Col>
                          </>
                      )}
                    </Row>
                  </Col>
              )
            })) : ''}
      </Row>
  );
};

export default FcltyFloorList;
